import React from 'react';
import Select from '@components/select';
import * as styles from './GroupSelect.scss';

const GroupSelect = (props) => {
  const {
    value,
    options,
    handleGroupSelectChange,
    dropdownWidth,
  } = props;

  return (
    <div className={styles.groupSelectContainer}>
      <Select
        options={options}
        value={value}
        onChange={handleGroupSelectChange}
        hideSelectAllButton
        valueProperty="value"
        labelProperty="label"
        dropdownWidth={dropdownWidth}
      />
    </div>
  );
};

export default GroupSelect;
